import { Navigate, Routes, Route } from 'react-router-dom'
import Home from './pages/home/Home.jsx'
import NotFound from './pages/NotFound.jsx'
import MetaTags from './components/MetaTags.jsx'
import Navbar from './components/navbar/Navbar.jsx'
import Footer from './components/footer/Footer.jsx'
import AboutUs from './pages/about-us/AboutUs.jsx'
import Benefits from './pages/benefits/Benefits.jsx'
import Blog from './pages/blog/Blog.jsx'
import Card from './pages/card/Card.jsx'
import Cashback from './pages/cashback/Cashback.jsx'
import Contact from './pages/Contact.jsx'
import ContactOut from './pages/ContactOut.jsx'
import Customers from './pages/Customers.jsx'
import Discounts from './pages/discounts/Discounts.jsx'
import Employees from './pages/employees/Employees.jsx'
import FAQ from './pages/faq/FAQ.jsx'
import HowItWorks from './pages/how-it-works/HowItWoks.jsx'
import Media from './pages/media/Media.jsx'
import PayrollCards from './pages/payroll-cards/PayrollCards.jsx'
import Remittances from './pages/remittances/Remittances.jsx'
import Signup from './pages/Signup.jsx'
import Tips from './pages/tips/Tips.jsx'
import Travel from './pages/travel/Travel.jsx'
import WageAccess from './pages/wage-access/WageAccess.jsx'
import ScrollToTop from './utils/ScrollTop.jsx'
import TermsAndConditions from './pages/T&C.jsx'
import { checkB2CSubdomain } from './utils/helpers.js'
import Paths from './utils/paths.js'
import { B2C_FEATURE_ACTIVE } from './utils/constants.js'

if (!B2C_FEATURE_ACTIVE) {
  const currentDomain = window.location.hostname.split('.')[0]
  const BASE_DOMAIN = 'multikrd'
  const DEV_DOMAINS = ['localhost', 'test', 'landing']
  if (currentDomain !== BASE_DOMAIN && !DEV_DOMAINS.includes(currentDomain)) {
    const baseURL = window.location.origin.replace(`${currentDomain}.`, '')
    window.location.replace(baseURL)
  }
}

function App () {
  const isB2C = B2C_FEATURE_ACTIVE ? checkB2CSubdomain() : false

  return (
    <div className='app'>
      <MetaTags />
      <ScrollToTop>
        <Navbar fixed />
        <Routes>
          <Route path={Paths.ROOT} element={isB2C ? <Customers /> : <Home />} />
          <Route path={Paths.HOME} element={<Home />} />
          <Route path={Paths.ABOUT_US} element={<AboutUs />} />
          <Route path={Paths.BENEFITS} element={<Benefits />} />
          <Route path={Paths.BLOG + '/:slug'} element={<Blog />} />
          <Route path={Paths.BLOG} element={<Blog />} />
          <Route path={Paths.PREPAID_CARDS} element={<Card />} />
          <Route path={Paths.CASHBACK} element={<Cashback />} />
          <Route path={Paths.CONTACT_US} element={<ContactOut />} />
          <Route path={Paths.CONTACT} element={<Contact />} />
          <Route path={Paths.DISCOUNTS} element={<Discounts />} />
          <Route path={Paths.EMPLOYEES} element={<Employees />} />
          <Route path={Paths.FAQS} element={<FAQ />} />
          <Route path={Paths.HOW_IT_WORKS} element={<HowItWorks />} />
          <Route path={Paths.LEGAL_AGREEMENTS} element={<TermsAndConditions />} />
          <Route path={Paths.MEDIA} element={<Media />} />
          <Route path={Paths.PAYROLL_CARDS} element={<PayrollCards />} />
          <Route path={Paths.REMITTANCES} element={<Remittances />} />
          <Route path={Paths.TIPS} element={<Tips />} />
          <Route path={Paths.TRAVEL} element={<Travel />} />
          <Route path={Paths.WAGE_ACCESS} element={<WageAccess />} />
          {B2C_FEATURE_ACTIVE && (
            <>
              <Route path={Paths.CUSTOMERS} element={<Customers />} />
              <Route path={Paths.SIGNUP} element={<Signup />} />
            </>
          )}
          <Route path='*' element={<NotFound />} />
        </Routes>
        <Footer />
      </ScrollToTop>
    </div>
  )
}

export default App
